import React from "react"
import { Divider, Stack } from "@mui/material"
import { CachedOutlined } from "@mui/icons-material"
import { useAppSelector } from "../../app/hooks"
import { UserRole } from "../../constants/data"
import { selectLogin } from "../../slices/loginSlice"
import { selectTransactions } from "../../slices/transactionsSlice"
import { useNavigate } from "react-router-dom"
import { computeRoute } from "../../utils/compute-route"
import { BANK_ACCOUNTS_VIEW } from "../../constants/path"
import AddIcon from "@mui/icons-material/Add"
import { PrimaryButton, StyledButton } from "../Transactions/styles"

interface PageHeaderActionProps {
  handleRefresh: () => void
}

export const PageHeaderAction: React.FC<PageHeaderActionProps> = ({
  handleRefresh,
}) => {
  const { role } = useAppSelector(selectLogin)
  const navigate = useNavigate()

  const { isUploading } = useAppSelector(selectTransactions)

  return (
    <Stack spacing={1} direction="row">
      <PrimaryButton
        variant="contained"
        startIcon={<AddIcon fontSize="small" />}
        onClick={() =>
          navigate(computeRoute(BANK_ACCOUNTS_VIEW, { bankAccountId: "add" }))
        }
        disabled={
          isUploading ||
          role === UserRole.ACCOUNT ||
          role === UserRole.ALTS_SALES
        }
      >
        Add Account
      </PrimaryButton>

      <Divider orientation="vertical" flexItem />
      <StyledButton
        variant="outlined"
        startIcon={<CachedOutlined fontSize="small" />}
        color="inherit"
        onClick={handleRefresh}
      >
        Refresh
      </StyledButton>
    </Stack>
  )
}
